module.exports = __webpack_public_path__ + "static/img/花瓶10.acf0d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶10.png
// module id = TcKL
// module chunks = 2